import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import React from 'react';
import styles from './PostMenuTrigger.mscss';

interface OwnProps {
    className?: string;
    onClick: React.MouseEventHandler<HTMLElement>;
}

type Props = OwnProps;

class PostMenuTrigger extends React.Component<Props> {

    public render() {
        const { className, onClick } = this.props;

        return (
            <div
                className={cx(styles.PostMenuTrigger, className)}
                onClick={onClick}
                role="button"
                tabIndex={0}
            >
                <FontAwesomeIcon icon={faChevronDown} />
            </div>
        );
    }

}

export default PostMenuTrigger;
